import { TablePage } from "~/components/Table";
import { GroupFilters } from "./components/GroupFilters";
import {
  GroupSearchRequestProvider,
  GroupTable,
} from "./components/GroupTable";

export function GroupsPage() {
  return (
    <TablePage
      title="Search Groups"
      RequestProvider={GroupSearchRequestProvider}
      table={<GroupTable />}
      filters={<GroupFilters />}
    />
  );
}
